const ActionType = (actionType) => `APPLICATION_${actionType}`;

export const GA_PAGE_VIEW = ActionType('GA_PAGE_VIEW');
export const CHANGE_CONSENT = ActionType('CHANGE_CONSENT');
export const CHANGE_PRIVACY_POLICY = ActionType('CHANGE_PRIVACY_POLICY');
export const GOOG_PAL_UPDATED = ActionType('GOOG_PAL_UPDATED');
